import { render, staticRenderFns } from "./Add_Quiz.vue?vue&type=template&id=1a78b688&scoped=true&"
import script from "./Add_Quiz.vue?vue&type=script&lang=js&"
export * from "./Add_Quiz.vue?vue&type=script&lang=js&"
import style0 from "./Add_Quiz.vue?vue&type=style&index=0&id=1a78b688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a78b688",
  null
  
)

export default component.exports